<template>
  <div>
    <PageTitleVue
      :sub-title="'Adicione uma nova turma'"
    >
      Cadastrar turma

      <!-- go back -->
      <template #b-action>
        <Create
          @click="router.push('/fighters')"
          :icon="PhArrowLeft"
          :label="'Voltar'"
          :menu-active="'Lutadores'"
        />
      </template>

    </PageTitleVue>

    <Form
      id="form-fields"
      :create="true"
      :descriptionTitle="'Dados do grupo'"
    >
      <div class="w-full flex justify-center mt-4">
        <CreateButton
          @click="newGroup"
          :icon="'fa-solid fa-user-plus'"
          :label="'Adicionar'"
        />
      </div>
    </Form>

    <!-- <FloatBackPage /> -->
  </div>
</template>

<script setup>
import PageTitleVue from '@/components/Titles/PageTitle.vue'
import CreateButton from '@/components/Buttons/Create.vue'
import Create from '@/components/Buttons/Create.vue'
import Form from './GroupForm.vue'
import * as yup from '@/validator'
import { dataGroups } from '../store/groups'
import { storeApp } from '@/store'
import { setFormFieldsError, validateFormField } from '@/helpers/formFieldsHandler'
import { onBeforeMount } from 'vue'
import { showToast as toast } from '@/helpers/UseToasts'
import router from '@/router'
import { PhArrowLeft } from '@phosphor-icons/vue'
import groupService from '../services/group.service'

const appStore = storeApp
const store = dataGroups

const form = yup.object().shape({
  name: yup.string().required('Informe o nome da turma').label('Turma').min(3).max(100)
})

onBeforeMount(async () => {
  appStore.state.loading = true
  store.commit('RESET_FORM')
  appStore.state.loading = false
})

// registra um novo colaborador
async function newGroup () {
  appStore.state.loading = true

  const validate = (await validateFormField(form, store.state.form))
  if (validate && validate.length > 0) {
    setFormFieldsError(validate)
    appStore.state.loading = false
    console.log(validate)

    toast(
      'Aviso',
      'Campos obrigatórios não preenchidos',
      'error'
    )

    return
  }

  const data = Object.assign({}, store.state.form)

  await groupService.newGroup(data)
    .then(res => {
      appStore.state.loading = false
      if (res.data.success) {
        toast(
          'Sucesso',
          res.data.message,
          'success'
        )

        dataGroups.dispatch('getGroups')
      }
    })
    .catch(err => {
      appStore.state.loading = false

      if (err.response.status && err.response.status === 400) {
        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      toast(
        'Erro',
        err.response.data.error,
        'error'
      )
    })
}

</script>

<style lang="scss">
.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}
</style>
